import { callAPi, callAPiMultiPart } from "./api";

const create = (data) => callAPiMultiPart.post("/admin/board-members", data);
const edit = (data, id) =>
  callAPiMultiPart.patch(`/admin/board-members/${id}`, data);
const get = () => callAPi.get("/board-members");
const getCurrent = () =>
  callAPi.get("/board-members", { params: { currentOnly: "true" } });
const getArchived = () => callAPi.get("/board-members/archived/list");
const getByID = (id) => callAPi.get(`/board-members/${id}`);
// For ending a term we use the dedicated endpoint (no file upload middleware)
const endTerm = (id, endDate) =>
  callAPi.patch(`/admin/board-members/${id}/end-term`, { endDate });
// Clear end date so member becomes current again
const makeCurrent = (id) =>
  callAPi.patch(`/admin/board-members/${id}/make-current`);

const deleteBoardMember = (id) => callAPi.delete(`/admin/board-members/${id}`);

const boardServices = {
  create,
  edit,
  get,
  getCurrent,
  getArchived,
  getByID,
  endTerm,
  makeCurrent,
  deleteBoardMember,
};

export default boardServices;
